const $04410b3b959a494a$export$a3b296e0cf6c903d = $04410b3b959a494a$export$d29f2533ab4f8bcf();
class $04410b3b959a494a$export$f7a70f5f17339408 extends Error {
    constructor(message){
        super(message);
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
function $04410b3b959a494a$export$d29f2533ab4f8bcf() {
    return Object.create(null);
}
function $04410b3b959a494a$export$848feb93d8f32b9b(func) {
    try {
        func();
    } catch (e) {
        window.reportError(e);
    }
}
function $04410b3b959a494a$export$8b1ffc2729584f1c(cb, ...args) {
    setTimeout(()=>cb(...args), 0);
}
function $04410b3b959a494a$export$7cf43de860abed3c(cb) {
    function loadCb() {
        $04410b3b959a494a$export$8b1ffc2729584f1c(cb);
        document.removeEventListener("DOMContentLoaded", loadCb);
        window.removeEventListener("load", loadCb);
    }
    if (document.readyState === "interactive" || document.readyState === "complete") return loadCb();
    document.addEventListener("DOMContentLoaded", loadCb);
    window.addEventListener("load", loadCb);
}
function $04410b3b959a494a$export$8bf7aba4a9e09055(errorMessage, ErrCls = Error) {
    throw new ErrCls(errorMessage);
}
function $04410b3b959a494a$export$1a59691a1efaf7b9(ErrCls) {
    return function(errorMessage) {
        $04410b3b959a494a$export$8bf7aba4a9e09055(errorMessage, ErrCls);
    };
}
function $04410b3b959a494a$export$810b1114454c23e0(val, min, max) {
    let res = val;
    if (res < min) res = min;
    if (res > max) res = max;
    return res;
}
function $04410b3b959a494a$export$34ef6013e28b271b(a, b) {
    const d = BigInt(a) - BigInt(b);
    if (d > 0n) return 1;
    if (d < 0n) return -1;
    return 0;
}
function $04410b3b959a494a$export$de363e709c412c8a(func, time) {
    let args = []; // 😿
    let tm = null;
    function callFn() {
        try {
            func(args);
        } catch (e) {
            window.reportError(e);
        }
        args = [];
        tm = null;
    }
    return function throttled(arg) {
        args.push(arg);
        if (!tm) tm = setTimeout(callFn, time);
    };
}
const $04410b3b959a494a$export$7203b6f87333b9a2 = new Intl.NumberFormat(globalThis?.navigator?.language ?? "en-US");


var $6e33178611e38e36$export$f2555f7082964729;
(function(GameOfLifeState) {
    GameOfLifeState["Stopped"] = "Stopped";
    GameOfLifeState["Running"] = "Running";
    GameOfLifeState["Stopping"] = "Stopping";
    GameOfLifeState["Completed"] = "Completed";
})($6e33178611e38e36$export$f2555f7082964729 || ($6e33178611e38e36$export$f2555f7082964729 = {}));
class $6e33178611e38e36$export$8981e2cb2c3fa123 {
    constructor(lifeMap){
        this._stopFlag = false;
        this._startCallbacks = [];
        this._stopCallbacks = [];
        this._roundCallbacks = [];
        this._state = $6e33178611e38e36$export$f2555f7082964729.Stopped;
        this._roundStartTime = 0;
        this._runRoundAsync = (done)=>{
            this._roundStartTime = Date.now();
            const aliveLocs = this._lifeMap.getLifeLocalities();
            const changesTable = (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
            for (const [xVal, yVal] of aliveLocs){
                const state = this._lifeMap.isAlive(xVal, yVal);
                let aliveSiblings = 0;
                for(let i = xVal - 1n; i <= xVal + 1n; ++i){
                    for(let j = yVal - 1n; j <= yVal + 1n; ++j)if (!(i === xVal && j === yVal)) aliveSiblings += this._lifeMap.isAlive(i, j) ? 1 : 0;
                }
                if (state && !(aliveSiblings === 2 || aliveSiblings === 3)) (changesTable[xVal.toString()] ??= (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)())[yVal.toString()] = false;
                else if (!state && aliveSiblings === 3) (changesTable[xVal.toString()] ??= (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)())[yVal.toString()] = true;
            }
            done(changesTable);
        };
        this._lifeMap = lifeMap;
    }
    get state() {
        return this._state;
    }
    onStart(cb) {
        this._startCallbacks.push(cb);
    }
    onStop(cb) {
        this._stopCallbacks.push(cb);
    }
    onRound(cb) {
        this._roundCallbacks.push(cb);
    }
    stop() {
        this._stopFlag = true;
        this._state = $6e33178611e38e36$export$f2555f7082964729.Stopping;
    }
    run() {
        const onRoundComplete = (changesTable)=>{
            let changed = false;
            for (const [keyX, yVector] of Object.entries(changesTable))for (const [keyY, state] of Object.entries(yVector ?? (0, $04410b3b959a494a$export$a3b296e0cf6c903d))){
                this._lifeMap.isAlive(keyX, keyY, state ?? false);
                changed = true;
            }
            (0, $04410b3b959a494a$export$8b1ffc2729584f1c)(()=>{
                this._roundCallbacks.forEach((0, $04410b3b959a494a$export$848feb93d8f32b9b));
            });
            if (!changed) {
                this._state = $6e33178611e38e36$export$f2555f7082964729.Completed;
                (0, $04410b3b959a494a$export$8b1ffc2729584f1c)(()=>{
                    this._stopCallbacks.forEach((0, $04410b3b959a494a$export$848feb93d8f32b9b));
                });
            } else if (this._stopFlag) {
                this._state = $6e33178611e38e36$export$f2555f7082964729.Stopped;
                (0, $04410b3b959a494a$export$8b1ffc2729584f1c)(()=>{
                    this._stopCallbacks.forEach((0, $04410b3b959a494a$export$848feb93d8f32b9b));
                });
            } else makeRound();
        };
        const makeRound = ()=>{
            const delta = $6e33178611e38e36$export$8981e2cb2c3fa123.ROUND_TIME - (Date.now() - this._roundStartTime);
            setTimeout(()=>this._runRoundAsync(onRoundComplete), delta);
        };
        this._stopFlag = false;
        this._roundStartTime = Date.now();
        makeRound();
        this._state = $6e33178611e38e36$export$f2555f7082964729.Running;
        (0, $04410b3b959a494a$export$8b1ffc2729584f1c)(()=>{
            this._startCallbacks.forEach((0, $04410b3b959a494a$export$848feb93d8f32b9b));
        });
    }
}
$6e33178611e38e36$export$8981e2cb2c3fa123.ROUND_TIME = 250;


class $f2e1af450a1a0fc7$export$f3625401589af144 {
    constructor(mapView){
        this._mapView = mapView;
    }
    removeSave(saveName = $f2e1af450a1a0fc7$export$f3625401589af144.BUTTON_SAVE_NAME) {
        delete localStorage[saveName];
    }
    save(saveName = $f2e1af450a1a0fc7$export$f3625401589af144.BUTTON_SAVE_NAME) {
        window.localStorage[saveName] = this._mapView.getSaveString();
    }
    load(saveName = $f2e1af450a1a0fc7$export$f3625401589af144.BUTTON_SAVE_NAME) {
        if (this.doesSaveExist(saveName)) {
            const dump = window.localStorage[saveName];
            this._mapView.loadSaveFromString(dump);
        }
    }
    doesSaveExist(saveName = $f2e1af450a1a0fc7$export$f3625401589af144.BUTTON_SAVE_NAME) {
        const dump = window.localStorage[saveName];
        return Boolean(dump);
    }
}
$f2e1af450a1a0fc7$export$f3625401589af144.BUTTON_SAVE_NAME = "save";
$f2e1af450a1a0fc7$export$f3625401589af144.AUTO_SAVE_NAME = "auto_save";



class $9935fb0976009b53$export$4e5402614c278aa0 extends (0, $04410b3b959a494a$export$f7a70f5f17339408) {
}
const $9935fb0976009b53$var$thr = (0, $04410b3b959a494a$export$1a59691a1efaf7b9)($9935fb0976009b53$export$4e5402614c278aa0);
class $9935fb0976009b53$export$73d419e4fd660e9b {
    constructor(params){
        this._disableAutosave = false;
        this._lifeMap = params.lifeMap;
        this._mapView = params.mapView;
        this._game = params.game;
        this._saveGameController = params.saveGameController;
        this._messagesView = params.messagesView;
        this._startButton = document.getElementById("start") ?? $9935fb0976009b53$var$thr("Button not found");
        this._stopButton = document.getElementById("stop") ?? $9935fb0976009b53$var$thr("Button not found");
        this._centerButton = document.getElementById("center") ?? $9935fb0976009b53$var$thr("Button not found");
        this._noZoomButton = document.getElementById("no-zoom") ?? $9935fb0976009b53$var$thr("Button not found");
        this._saveButton = document.getElementById("save") ?? $9935fb0976009b53$var$thr("Button not found");
        this._loadButton = document.getElementById("load") ?? $9935fb0976009b53$var$thr("Button not found");
        this._resetButton = document.getElementById("reset") ?? $9935fb0976009b53$var$thr("Button not found");
        this._helpShowButton = document.getElementById("help-button") ?? $9935fb0976009b53$var$thr("Button not found");
        this._helpCloseButton = document.getElementById("help__close") ?? $9935fb0976009b53$var$thr("Button not found");
        this._helpBlock = document.getElementById("help") ?? $9935fb0976009b53$var$thr("Help not found");
    }
    init() {
        window.addEventListener("click", (e)=>{
            if (e.target === this._resetButton) return;
            this._disableAutosave = false;
        });
        this._game.onStart(()=>{
            this._startButton.setAttribute("disabled", "");
            this._stopButton.removeAttribute("disabled");
            this._loadButton.setAttribute("disabled", "");
            this._resetButton.setAttribute("disabled", "");
        });
        this._game.onStop(()=>{
            this._stopButton.setAttribute("disabled", "");
            this._startButton.removeAttribute("disabled");
            if (this._saveGameController.doesSaveExist()) this._loadButton.removeAttribute("disabled");
            if (this._game.state === (0, $6e33178611e38e36$export$f2555f7082964729).Completed) this._messagesView.showMessage("The game is completed!");
            this._resetButton.removeAttribute("disabled");
        });
        this._startButton.onclick = ()=>{
            this._game.run();
        };
        this._stopButton.onclick = ()=>{
            this._game.stop();
        };
        this._centerButton.onclick = ()=>{
            this._mapView.moveToCenter();
        };
        this._noZoomButton.onclick = ()=>{
            this._mapView.resetCellsSize();
        };
        this._saveButton.onclick = ()=>{
            this._saveGameController.save();
        };
        this._loadButton.onclick = ()=>{
            this._saveGameController.load();
        };
        if (this._saveGameController.doesSaveExist()) {
            this._loadButton.removeAttribute("disabled");
            this._messagesView.showMessage("You have a saved game");
        }
        this._resetButton.onclick = ()=>{
            this._disableAutosave = true;
            this._saveGameController.removeSave((0, $f2e1af450a1a0fc7$export$f3625401589af144).AUTO_SAVE_NAME);
            window.location.reload();
        };
        this._helpShowButton.onclick = ()=>{
            this._helpBlock.classList.remove("help_hidden");
        };
        this._helpCloseButton.onclick = ()=>{
            this._helpBlock.classList.add("help_hidden");
        };
        window.addEventListener("beforeunload", ()=>{
            if (this._disableAutosave) return;
            this._saveGameController.save((0, $f2e1af450a1a0fc7$export$f3625401589af144).AUTO_SAVE_NAME);
        });
        if (this._saveGameController.doesSaveExist((0, $f2e1af450a1a0fc7$export$f3625401589af144).AUTO_SAVE_NAME)) this._saveGameController.load((0, $f2e1af450a1a0fc7$export$f3625401589af144).AUTO_SAVE_NAME);
    }
}




const $f22807430230dcbd$export$5ee3d7a76ea08ff5 = 2n ** 20n;
const $f22807430230dcbd$export$9f90d91e5869b057 = 2n ** 64n;
let $f22807430230dcbd$export$cf15332af378c0c6 = $f22807430230dcbd$export$5ee3d7a76ea08ff5;
if (window.location.href.search(/[?&]huge-universe=1(?:&|$)/) > -1) $f22807430230dcbd$export$cf15332af378c0c6 = $f22807430230dcbd$export$9f90d91e5869b057;
class $f22807430230dcbd$export$3f79031f6bd0d508 extends (0, $04410b3b959a494a$export$f7a70f5f17339408) {
}
function $f22807430230dcbd$export$d2899eefa4175145(a, b) {
    const d = (0, $04410b3b959a494a$export$34ef6013e28b271b)(a[0], b[0]);
    if (d) return d;
    return (0, $04410b3b959a494a$export$34ef6013e28b271b)(a[1], b[1]);
}
class $f22807430230dcbd$export$ed3ad1bc61bbbf61 {
    constructor(mapWidth = $f22807430230dcbd$export$cf15332af378c0c6, mapHeight = $f22807430230dcbd$export$cf15332af378c0c6){
        this._container = (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
        this._width = 0n;
        this._height = 0n;
        this._minX = 0n;
        this._maxX = 0n;
        this._minY = 0n;
        this._maxY = 0n;
        this._changeListeners = [];
        this._width = BigInt(mapWidth);
        this._height = BigInt(mapHeight);
        this.reset();
    }
    static stringifySaveData(data) {
        return data.join(";");
    }
    static parseSaveString(dump) {
        return dump.split(";");
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get populatedRect() {
        return {
            left: this._minX,
            right: this._maxX,
            top: this._minY,
            bottom: this._maxY
        };
    }
    get container() {
        return this._container;
    }
    isAlive(x, y, status) {
        x = BigInt(x);
        y = BigInt(y);
        if (x < 0n || x >= this._width || y < 0n || y >= this._height) return false;
        if (status !== undefined) this._setStatusToContainer(x, y, status);
        const keyX = x.toString();
        const keyY = y.toString();
        return Boolean(this._container[keyX]?.[keyY]);
    }
    getLifeLocalities() {
        /* eslint-disable guard-for-in */ // About key iteration order: https://dev.to/frehner/the-order-of-js-object-keys-458d
        const res = [];
        const passedCache = new Map();
        const container = this._container;
        const mapWidth = this._width;
        const mapHeight = this._height;
        for(const xKey in container){
            const xVal = BigInt(xKey);
            for(const yKey in container[xKey]){
                const yVal = BigInt(yKey);
                for(let i = xVal - 1n; i <= xVal + 1n; ++i)for(let j = yVal - 1n; j <= yVal + 1n; ++j){
                    if (passedCache.get(i)?.has(j) === true || i < 0n || i >= mapWidth || j < 0n || j >= mapHeight) continue;
                    let curPassedLine = passedCache.get(i);
                    if (!curPassedLine) {
                        curPassedLine = new Set();
                        passedCache.set(i, curPassedLine);
                    }
                    curPassedLine.add(j);
                    res.push([
                        i,
                        j
                    ]);
                }
            }
        }
        return res.sort($f22807430230dcbd$export$d2899eefa4175145);
    }
    addChangeListener(listener) {
        if (this._changeListeners.indexOf(listener) === -1) this._changeListeners.push(listener);
    }
    reset() {
        this._container = (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
        this._minX = this._height - 1n;
        this._maxX = 0n;
        this._minY = this._width - 1n;
        this._maxY = 0n;
        this._changeListeners.forEach((0, $04410b3b959a494a$export$848feb93d8f32b9b));
    }
    getSaveData() {
        const data = [
            this._width,
            this._height,
            this._minX,
            this._maxX,
            this._minY,
            this._maxY
        ];
        const coords = [];
        for (const [keyX, vector] of Object.entries(this._container))coords.push(`${keyX}:${Object.keys(vector ?? (0, $04410b3b959a494a$export$a3b296e0cf6c903d)).join(",")}`);
        data.push(coords.join("|"));
        return data;
    }
    loadSaveData(data) {
        if (data.length < 7) throw new $f22807430230dcbd$export$3f79031f6bd0d508("Invalid save data length");
        this._width = BigInt(data[0]);
        this._height = BigInt(data[1]);
        this._minX = BigInt(data[2]);
        this._maxX = BigInt(data[3]);
        this._minY = BigInt(data[4]);
        this._maxY = BigInt(data[5]);
        const container = this._container = (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
        for (const coordData of data[6].split("|")){
            const [keyX, yStr] = coordData.split(":");
            if (!keyX || !yStr) continue;
            const xVector = container[keyX] = (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
            for (const keyY of yStr.split(","))xVector[keyY] = true;
        }
    }
    _setStatusToContainer(bigX, bigY, status) {
        const keyX = bigX.toString();
        const keyY = bigY.toString();
        if (status) {
            const xVector = this._container[keyX] ??= (0, $04410b3b959a494a$export$d29f2533ab4f8bcf)();
            xVector[keyY] = true;
        } else if (!status && this._container[keyX]) {
            delete this._container[keyX]?.[keyY];
            if (Object.keys(this._container[keyX] ?? (0, $04410b3b959a494a$export$a3b296e0cf6c903d)).length === 0) delete this._container[keyX];
        }
        if (!status) return;
        if (bigX - $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA < this._minX) {
            this._minX = bigX - $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA;
            if (this._minX < 0n) this._minX = 0n;
        }
        if (bigX + $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA > this._maxX) {
            this._maxX = bigX + $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA;
            if (this._maxX >= this._width) this._maxX = this._width - 1n;
        }
        if (bigY - $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA < this._minY) {
            this._minY = bigY - $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA;
            if (this._minY < 0n) this._minY = 0n;
        }
        if (bigY + $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA >= this._maxY) {
            this._maxY = bigY + $f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA;
            if (this._maxY >= this._height) this._maxY = this._height - 1n;
        }
    }
}
$f22807430230dcbd$export$ed3ad1bc61bbbf61.POPULATED_DELTA = 30n;



let $71541114d7dd9aeb$var$darkTheme = false;
try {
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) $71541114d7dd9aeb$var$darkTheme = true;
} catch (e) {
    window.reportError(e);
}
let $71541114d7dd9aeb$var$gridFill = "#616161";
let $71541114d7dd9aeb$var$gridStroke = "#bdbdbd";
let $71541114d7dd9aeb$var$gridBorderColor = "#fafafa";
if ($71541114d7dd9aeb$var$darkTheme) {
    $71541114d7dd9aeb$var$gridFill = "#bdbdbd";
    $71541114d7dd9aeb$var$gridStroke = "#616161";
    $71541114d7dd9aeb$var$gridBorderColor = "#000000";
}
var $71541114d7dd9aeb$export$2e2bcd8739ae039 = {
    darkTheme: $71541114d7dd9aeb$var$darkTheme,
    gridFill: $71541114d7dd9aeb$var$gridFill,
    gridStroke: $71541114d7dd9aeb$var$gridStroke,
    gridBorderColor: $71541114d7dd9aeb$var$gridBorderColor
};



class $4178208286d7fe59$export$a660f75ebdcef0d9 extends (0, $04410b3b959a494a$export$f7a70f5f17339408) {
}
const $4178208286d7fe59$var$thr = (0, $04410b3b959a494a$export$1a59691a1efaf7b9)($4178208286d7fe59$export$a660f75ebdcef0d9);
var $4178208286d7fe59$export$e83a796c10cd0c8d;
(function(MapViewState) {
    MapViewState["Initial"] = "Initial";
    MapViewState["Rendered"] = "Rendered";
    MapViewState["Input"] = "Input";
})($4178208286d7fe59$export$e83a796c10cd0c8d || ($4178208286d7fe59$export$e83a796c10cd0c8d = {}));
class $4178208286d7fe59$export$ab1e7a67d6ec5ad8 {
    constructor(lifeMap){
        this._state = $4178208286d7fe59$export$e83a796c10cd0c8d.Initial;
        this._cellWidth = $4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_WIDTH;
        this._cellHeight = $4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_HEIGHT;
        this._cellsByHorizontal = 0;
        this._cellsByVertical = 0;
        this._cellsHorizontalOffset = 0n;
        this._cellsVerticalOffset = 0n;
        this._curFrameRequest = null;
        this.render = ()=>{
            this._ctx.clearRect(0, 0, this._canvasWidth, this._canvasHeight);
            let i = this._cellsVerticalOffset;
            const M = i + BigInt(this._cellsByVertical);
            for(; i <= M; ++i){
                let j = this._cellsHorizontalOffset;
                const N = j + BigInt(this._cellsByHorizontal);
                for(; j <= N; ++j)this._setCellState(i, j, this._lifeMap.isAlive(i, j));
            }
            if (this._state !== $4178208286d7fe59$export$e83a796c10cd0c8d.Input) this._state = $4178208286d7fe59$export$e83a796c10cd0c8d.Rendered;
            this._xValue.innerHTML = (0, $04410b3b959a494a$export$7203b6f87333b9a2).format(this._cellsVerticalOffset);
            this._yValue.innerHTML = (0, $04410b3b959a494a$export$7203b6f87333b9a2).format(this._cellsHorizontalOffset);
            const populated = this._lifeMap.populatedRect;
            this._popWidth.innerHTML = (0, $04410b3b959a494a$export$7203b6f87333b9a2).format((0, $04410b3b959a494a$export$810b1114454c23e0)(populated.right - populated.left, 0n, this._lifeMap.width));
            this._popHeight.innerHTML = (0, $04410b3b959a494a$export$7203b6f87333b9a2).format((0, $04410b3b959a494a$export$810b1114454c23e0)(populated.bottom - populated.top, 0n, this._lifeMap.height));
        };
        this.moveBy = (deltaX, deltaY)=>{
            this._cellsHorizontalOffset = (0, $04410b3b959a494a$export$810b1114454c23e0)(this._cellsHorizontalOffset + deltaX, 0n, this._lifeMap.width);
            this._cellsVerticalOffset = (0, $04410b3b959a494a$export$810b1114454c23e0)(this._cellsVerticalOffset + deltaY, 0n, this._lifeMap.height);
            this.renderWhenFrame();
        };
        this.moveToCenter = ()=>{
            this._setCenterOffsets();
            this.renderWhenFrame();
        };
        this.renderWhenFrame = ()=>{
            if (this._curFrameRequest) return;
            this._curFrameRequest = requestAnimationFrame(()=>{
                this._curFrameRequest = null;
                this.render();
            });
        };
        this.beginInput = ()=>{
            if (this._state !== $4178208286d7fe59$export$e83a796c10cd0c8d.Rendered) throw new Error("Input is not available");
            this._state = $4178208286d7fe59$export$e83a796c10cd0c8d.Input;
            this._canvas.addEventListener("click", this._inputListener);
        };
        this.endInput = ()=>{
            if (this._state !== $4178208286d7fe59$export$e83a796c10cd0c8d.Input) throw new $4178208286d7fe59$export$a660f75ebdcef0d9("Input is not available");
            this._state = $4178208286d7fe59$export$e83a796c10cd0c8d.Rendered;
            this._canvas.removeEventListener("click", this._inputListener);
        };
        this._inputListener = (event)=>{
            if (this._state !== $4178208286d7fe59$export$e83a796c10cd0c8d.Input) throw new $4178208286d7fe59$export$a660f75ebdcef0d9("The map not into INPUT state");
            const cell = this._getCellByClientCoordinates(event.clientX, event.clientY);
            this._toggleCellState(cell.top, cell.left);
        };
        this._lifeMap = lifeMap;
        this._canvas = document.getElementById("map") ?? $4178208286d7fe59$var$thr("Canvas not found");
        this._canvasRect = this._canvas.getBoundingClientRect();
        this._canvasWidth = this._canvas.clientWidth;
        this._canvasHeight = this._canvas.clientHeight;
        this._ctx = this._canvas.getContext("2d") ?? $4178208286d7fe59$var$thr("Failed to create context");
        this._ctx.fillStyle = (0, $71541114d7dd9aeb$export$2e2bcd8739ae039).gridFill;
        this._ctx.strokeStyle = (0, $71541114d7dd9aeb$export$2e2bcd8739ae039).gridStroke;
        this._xValue = document.getElementById("map-params__item-x") ?? $4178208286d7fe59$var$thr("No X value");
        this._yValue = document.getElementById("map-params__item-y") ?? $4178208286d7fe59$var$thr("No Y value");
        this._popWidth = document.getElementById("map-params__item-populated-width") ?? $4178208286d7fe59$var$thr("No pop width value");
        this._popHeight = document.getElementById("map-params__item-populated-height") ?? $4178208286d7fe59$var$thr("No pop width value");
        this._initMapData();
        this._lifeMap.addChangeListener(()=>{
            this._initMapData();
            this.renderWhenFrame();
        });
        new $4178208286d7fe59$var$MapViewNavigationHandler(this);
    }
    get canvas() {
        return this._canvas;
    }
    get cellWidth() {
        return this._cellWidth;
    }
    get cellHeight() {
        return this._cellHeight;
    }
    getSaveString() {
        const data = this._lifeMap.getSaveData();
        data.push(this._cellWidth, this._cellHeight, this._cellsHorizontalOffset, this._cellsVerticalOffset);
        return (0, $f22807430230dcbd$export$ed3ad1bc61bbbf61).stringifySaveData(data);
    }
    loadSaveFromString(dump) {
        const data = (0, $f22807430230dcbd$export$ed3ad1bc61bbbf61).parseSaveString(dump);
        this._lifeMap.loadSaveData(data);
        if (data.length < 11) {
            this._initMapData();
            return this.renderWhenFrame();
        }
        this._cellWidth = parseInt(data[7]) || $4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_WIDTH;
        this._cellHeight = parseInt(data[8]) || $4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_HEIGHT;
        this._initMapData(false);
        try {
            this._cellsHorizontalOffset = BigInt(data[9]);
            this._cellsVerticalOffset = BigInt(data[10]);
        } catch (e) {
            window.reportError(e);
            this._setCenterOffsets();
        }
        this.renderWhenFrame();
    }
    resizeCellsBy(delta) {
        const intDelta = Math.trunc(delta);
        const newWidth = this._cellWidth + intDelta;
        const newHeight = this._cellHeight + intDelta;
        this.setCellsSizes(newWidth, newHeight);
    }
    resetCellsSize() {
        this.setCellsSizes($4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_WIDTH, $4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_HEIGHT);
    }
    setCellsSizes(width, height) {
        let changed = false;
        if (this._cellWidth !== width && width >= $4178208286d7fe59$export$ab1e7a67d6ec5ad8.MIN_CELL_SIZE && width <= $4178208286d7fe59$export$ab1e7a67d6ec5ad8.MAX_CELL_SIZE) {
            this._cellWidth = width;
            changed = true;
        }
        if (this._cellHeight !== height && height >= $4178208286d7fe59$export$ab1e7a67d6ec5ad8.MIN_CELL_SIZE && height <= $4178208286d7fe59$export$ab1e7a67d6ec5ad8.MAX_CELL_SIZE) {
            this._cellHeight = height;
            changed = true;
        }
        if (changed) {
            const oldCenterX = this._cellsHorizontalOffset + BigInt(this._cellsByHorizontal) / 2n;
            const oldCenterY = this._cellsVerticalOffset + BigInt(this._cellsByVertical) / 2n;
            this._initMapData();
            this._cellsHorizontalOffset = oldCenterX - BigInt(this._cellsByHorizontal) / 2n;
            this._cellsVerticalOffset = oldCenterY - BigInt(this._cellsByVertical) / 2n;
            this.renderWhenFrame();
        }
    }
    _initMapData(setCentralOffset = true) {
        this._cellsByHorizontal = Math.floor(this._canvasWidth / this._cellWidth);
        if (this._cellsByHorizontal > this._lifeMap.width) throw new $4178208286d7fe59$export$a660f75ebdcef0d9("Map width is too low");
        this._cellsByVertical = Math.floor(this._canvasHeight / this._cellHeight);
        if (this._cellsByVertical > this._lifeMap.height) throw new $4178208286d7fe59$export$a660f75ebdcef0d9("Map height is too low");
        if (setCentralOffset) this._setCenterOffsets();
    }
    _setCenterOffsets() {
        this._cellsHorizontalOffset = (this._lifeMap.width - BigInt(this._cellsByHorizontal)) / 2n;
        this._cellsVerticalOffset = (this._lifeMap.height - BigInt(this._cellsByVertical)) / 2n;
    }
    _getCellByClientCoordinates(clientX, clientY) {
        const curVerticalOffset = BigInt(Math.trunc((clientY - this._canvasRect.top) / this._cellHeight));
        const curHorizontalOffset = BigInt(Math.trunc((clientX - this._canvasRect.left) / this._cellWidth));
        return {
            top: this._cellsVerticalOffset + curVerticalOffset,
            left: this._cellsHorizontalOffset + curHorizontalOffset
        };
    }
    _toggleCellState(i, j) {
        const isAlive = !this._lifeMap.isAlive(i, j);
        this._setCellState(i, j, isAlive);
    }
    _setCellState(i, j, isAlive) {
        this._lifeMap.isAlive(i, j, isAlive);
        const x = Number(j - this._cellsHorizontalOffset) * this._cellWidth;
        const y = Number(i - this._cellsVerticalOffset) * this._cellHeight;
        const ctx = this._ctx;
        if (isAlive) {
            ctx.fillRect(x, y, this._cellWidth, this._cellHeight);
            const baseStrokeStyle = ctx.strokeStyle;
            ctx.strokeStyle = (0, $71541114d7dd9aeb$export$2e2bcd8739ae039).gridBorderColor;
            ctx.strokeRect(x, y, this._cellWidth, this._cellHeight);
            ctx.strokeStyle = baseStrokeStyle;
        } else {
            ctx.clearRect(x, y, this._cellWidth, this._cellHeight);
            ctx.strokeRect(x, y, this._cellWidth, this._cellHeight);
        }
    }
}
$4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_WIDTH = 12;
$4178208286d7fe59$export$ab1e7a67d6ec5ad8.DEFAULT_CELL_HEIGHT = 12;
$4178208286d7fe59$export$ab1e7a67d6ec5ad8.MIN_CELL_SIZE = 5;
$4178208286d7fe59$export$ab1e7a67d6ec5ad8.MAX_CELL_SIZE = 22;
class $4178208286d7fe59$var$MapViewNavigationHandler {
    constructor(mapView){
        this._pointerLocked = false;
        this._onScroll = (events)=>{
            let deltaX = 0;
            let deltaY = 0;
            for (const event of events){
                if (event.metaKey || event.ctrlKey) continue;
                deltaX += event.deltaX;
                deltaY += event.deltaY;
            }
            if (!deltaX && !deltaY) return;
            const finalX = BigInt(Math.trunc(deltaX / this._mapView.cellWidth));
            const finalY = BigInt(Math.trunc(deltaY / this._mapView.cellHeight));
            if (finalX || finalY) this._mapView.moveBy(finalX, finalY);
        };
        this._onKey = (events)=>{
            if (!this._pointerLocked) return;
            let deltaX = 0;
            let deltaY = 0;
            let wasMod = false;
            for (const e of events){
                const action = $4178208286d7fe59$var$MapViewNavigationHandler.KEY_ACTIONS[e.code];
                switch(action){
                    case "up":
                        deltaY += 1;
                        break;
                    case "left":
                        deltaX += 1;
                        break;
                    case "down":
                        deltaY -= 1;
                        break;
                    case "right":
                        deltaX -= 1;
                        break;
                }
                if (action && (e.metaKey || e.ctrlKey)) wasMod = true;
            }
            if (wasMod && (deltaX || deltaY)) {
                let finalDelta = deltaX;
                if (Math.abs(deltaY) > Math.abs(deltaX)) finalDelta = deltaY;
                finalDelta = Math.round(finalDelta);
                this._mapView.resizeCellsBy(-finalDelta);
                return;
            }
            if (deltaX || deltaY) this._mapView.moveBy(BigInt(deltaX), BigInt(deltaY));
        };
        this._onZoom = (events)=>{
            let deltaX = 0;
            let deltaY = 0;
            for (const event of events){
                if (!event.metaKey && !event.ctrlKey) continue;
                deltaX -= event.deltaX;
                deltaY -= event.deltaY;
            }
            if (!deltaX && !deltaY) return;
            let finalDelta = deltaX;
            if (Math.abs(deltaY) > Math.abs(deltaX)) finalDelta = deltaY;
            finalDelta = Math.round(finalDelta / 10);
            this._mapView.resizeCellsBy(finalDelta);
        };
        this._lockPointer = ()=>{
            this._pointerLocked = true;
        };
        this._unlockPointer = ()=>{
            this._pointerLocked = false;
        };
        this._defaultPreventer = (e)=>{
            if (!this._pointerLocked) return;
            const isKey = e instanceof KeyboardEvent;
            const isMouse = e instanceof MouseEvent;
            if ((isKey || isMouse) && (e.shiftKey || e.altKey)) return;
            if (isKey && (e.ctrlKey || e.metaKey) && (e.code === "Digit0" || e.code === "Minus" || e.code === "Equal")) return;
            e.preventDefault();
        };
        this._mapView = mapView;
        this._onScrollThrottled = (0, $04410b3b959a494a$export$de363e709c412c8a)(this._onScroll, $4178208286d7fe59$var$MapViewNavigationHandler.SCROLL_TIMEOUT);
        this._onZoomThrottled = (0, $04410b3b959a494a$export$de363e709c412c8a)(this._onZoom, $4178208286d7fe59$var$MapViewNavigationHandler.ZOOM_TIMEOUT);
        this._onKeyThrottled = (0, $04410b3b959a494a$export$de363e709c412c8a)(this._onKey, $4178208286d7fe59$var$MapViewNavigationHandler.KEY_TIMEOUT);
        const canvas = this._mapView.canvas;
        canvas.addEventListener("mouseenter", this._lockPointer);
        canvas.addEventListener("mouseleave", this._unlockPointer);
        canvas.addEventListener("wheel", this._onScrollThrottled);
        canvas.addEventListener("wheel", this._onZoomThrottled);
        canvas.addEventListener("wheel", this._defaultPreventer);
        window.addEventListener("keydown", this._onKeyThrottled);
        window.addEventListener("keydown", this._defaultPreventer);
    }
}
$4178208286d7fe59$var$MapViewNavigationHandler.SCROLL_TIMEOUT = 32;
$4178208286d7fe59$var$MapViewNavigationHandler.KEY_TIMEOUT = 16;
$4178208286d7fe59$var$MapViewNavigationHandler.ZOOM_TIMEOUT = 75;
$4178208286d7fe59$var$MapViewNavigationHandler.KEY_ACTIONS = {
    KeyW: "up",
    KeyA: "left",
    KeyS: "down",
    KeyD: "right",
    ArrowUp: "up",
    ArrowLeft: "left",
    ArrowDown: "down",
    ArrowRight: "right",
    __proto__: null
};


class $054b22ee4f1298ef$export$ca6507f6a8b25a1d {
    constructor(){
        this._container = document.createElement("div");
        this._container.className = "messages-container";
        document.body.appendChild(this._container);
    }
    showMessage(message, className) {
        className = className ?? "info";
        const block = document.createElement("div");
        const closeButton = document.createElement("span");
        block.classList.add("message");
        block.classList.add(className);
        block.innerHTML = message;
        closeButton.className = "close";
        closeButton.innerHTML = "&times;";
        block.appendChild(closeButton);
        this._container.appendChild(block);
        const closeMessage = ()=>{
            this._container.removeChild(block);
            closeButton.onclick = null;
        };
        const closeTimeout = setTimeout(closeMessage, $054b22ee4f1298ef$export$ca6507f6a8b25a1d.LIFE_TIME);
        closeButton.onclick = function() {
            clearTimeout(closeTimeout);
            closeMessage();
            return false;
        };
    }
    showError(message) {
        this.showMessage(message, "error");
    }
    bindToErrors() {
        window.addEventListener("error", (event)=>{
            if (event.filename.startsWith("chrome")) return;
            this.showError(`An error has occurred: ${event.error}`);
        });
        window.addEventListener("unhandledrejection", (event)=>{
            this.showError(`An error has occurred: ${event.reason}`);
        });
    }
}
$054b22ee4f1298ef$export$ca6507f6a8b25a1d.LIFE_TIME = 10000;




(0, $04410b3b959a494a$export$7cf43de860abed3c)(function() {
    const messagesView = new (0, $054b22ee4f1298ef$export$ca6507f6a8b25a1d)();
    messagesView.bindToErrors();
    const lifeMap = new (0, $f22807430230dcbd$export$ed3ad1bc61bbbf61)();
    const mapView = new (0, $4178208286d7fe59$export$ab1e7a67d6ec5ad8)(lifeMap);
    const game = new (0, $6e33178611e38e36$export$8981e2cb2c3fa123)(lifeMap);
    const saveGameController = new (0, $f2e1af450a1a0fc7$export$f3625401589af144)(mapView);
    const controlsView = new (0, $9935fb0976009b53$export$73d419e4fd660e9b)({
        lifeMap: lifeMap,
        mapView: mapView,
        game: game,
        saveGameController: saveGameController,
        messagesView: messagesView
    });
    game.onStart(mapView.endInput);
    game.onStop(mapView.beginInput);
    game.onRound(mapView.renderWhenFrame);
    mapView.render();
    mapView.beginInput();
    controlsView.init();
    console.log("Game is ready!");
    window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", ()=>{
        window.location.reload();
    });
});


//# sourceMappingURL=index.c1fe54f8.js.map
